<template>
    <div>
        <div class="form-group">
            <label class="control-label">Company</label>
            <company v-model="model.company" :min-length="0"></company>
        </div>

        <div class="form-group">
            <label class="control-label">API Type</label>
            <select class="form-control" v-model="model.api">
                <option value="Asana">Asana</option>
                <option value="Sharepoint">Sharepoint</option>
                <option value="PandaDoc">PandaDoc</option>
                <option value="Custom">Custom Link</option>
            </select>
        </div>

        <div class="form-group" v-show="model.api === 'Asana'">
            <label class="control-label">Find Asana Project</label>
            <asana-project-list v-model="model.data"></asana-project-list>
        </div>

        <div v-show="model.api !== 'Asana'">
            <div class="form-group">
                <label class="control-label">Name</label>
                <input class="form-control" type="text" v-model="model.data.name">
            </div>

            <div class="form-group">
                <label class="control-label">URL</label>
                <input class="form-control" type="text" v-model="model.data.url">
            </div>
        </div>

        <div class="buttons">
            <button @click.prevent="store" type="submit" class="btn btn-success btn-sm">
                <span>Create</span>
            </button>
        </div>
    </div>
</template>
<script>
    import AsanaProjectList from "../../components/asana-project-list";
    export default {
        components: {
            AsanaProjectList,
            'company': require('../../components/autocomplete/company.vue').default,
        },
        data() {
            return {
                closePanel: true,
                model: {
                    company: '',
                    api: 'Custom',
                    data: {
                        name: '',
                        url: ''
                    }
                }
            }
        },
        created() {
        },
        watch: {
            'model.api': function(value, oldVal) {
                this.model.data.name = value;
            }
        },
        methods: {
            reset() {
                this.model = {
                    company: '',
                    api: 'Custom',
                    data: {
                        name: '',
                        url: ''
                    }
                }
            },
            callback(data) {
                // this.$eventHub.$emit('closeRightPanel');
            },
            store() {
                this.$store('/api/links/store', this);
            },
        },
        // It's good to clean up event listeners before a component is destroyed.
        beforeDestroy () {
        }
    }
</script>
<style>
    #savedLinks {
        text-align: center;
        min-height: 100px;
    }
    .clickable{
        cursor: pointer;
    }
</style>